import { render, staticRenderFns } from "./MovieCategory.vue?vue&type=template&id=04866c0f&"
import script from "./MovieCategory.vue?vue&type=script&lang=js&"
export * from "./MovieCategory.vue?vue&type=script&lang=js&"
import style0 from "./MovieCategory.vue?vue&type=style&index=0&id=04866c0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports